import(/* webpackMode: "eager" */ "/opt/render/project/src/app/[locale]/template.tsx");
